<template>
  <div>
    <div class="flex justify-between mb-2">
      <SegmentSelector v-model="segment" />

      <ButtonSwitch
        v-model="stacked"
        :options="groupingOptions"
        class="bg-gray-100 p-1 shadow-inner text-xs rounded-full hidden sm:block"
        item-class="text-gray-600 rounded-full hover:text-gray-700 focus:text-gray-700 transition font-medium py-2 px-4 bg-transparent focus:outline-none truncate sm:overflow-visible w-24 sm:w-auto"
        item-active-class="text-primary-700 hover:text-primary-700 focus:text-primary-800 ring-transparent ring-0"
      />
    </div>

    <div class="h-6 items-center hidden sm:flex mt-2 mb-4 sm:mt-4">
      <div
        v-if="!stacked"
        class="grid gap-4 md:gap-8 w-full"
        :class="{
          'grid-cols-4': axis.length === 4,
          'grid-cols-3': axis.length === 3,
        }"
      >
        <button
          v-for="(key, val) in order"
          :key="key"
          @click="setOrder(val)"
          class="btn w-full justify-center inline-flex items-center border-none p-0 text-xs font-medium shadow-none hover:shadow-none truncate rounded-sm"
        >
          {{ val }}
          <VerticalArrow v-if="orderBy === val" :dir="!orderDir" class="ml-2" />
        </button>
      </div>
    </div>

    <div class="relative mb-4">
      <XAxis
        v-if="stacked"
        class="absolute w-full h-full text-gray-500"
        :tick-values="[0, 50, 100]"
      />
      <div v-else class="absolute w-full h-full text-gray-500">
        <div
          class="grid gap-4 md:gap-8 h-full"
          :class="{
            'grid-cols-4': axis.length === 4,
            'grid-cols-3': axis.length === 3,
          }"
        >
          <XAxis
            v-for="(max, i) in axis"
            :key="i"
            :domain="[0, max]"
            :tick-values="[0, max]"
            class="h-full"
          />
        </div>
      </div>
      <StackedBarChart
        bar-class="bg-primary"
        :data="barData"
        :color-classes="colors"
        :stacked="stacked"
      />
      <!-- <div
        v-if="stacked"
        class="w-1/2 transform translate-x-px translate-y-6 absolute border-r-2 border-gray-500 top-0 bottom-0"
      ></div> -->
    </div>
  </div>
</template>

<script>
import StackedBarChart from "@/components/StackedBarChart";
import ButtonSwitch from "@/components/ButtonSwitch";
import XAxis from "@/components/XAxis";
import VerticalArrow from "@/components/VerticalArrow";
import SegmentSelector from "@/components/SegmentSelector";
import data from "@/assets/data/data";
import IDS from "@/utils/ids";
import { group, max } from "d3";

export default {
  components: {
    StackedBarChart,
    ButtonSwitch,
    XAxis,
    VerticalArrow,
    SegmentSelector,
  },
  props: {
    question: {
      type: Number,
      required: true,
    },
    order: {
      type: Object,
      required: true,
    },
    colors: {
      type: Object,
      required: true,
    },
    defaultOrder: {
      type: String,
      default: "Muy bueno",
    },
  },
  data() {
    return {
      data: group(
        data[this.question]
          .filter((e) => e[IDS.QUESTION_SUBNUMBER] === "")
          // remove NS/NC for question 13 - values are too small
          .filter((e) =>
            this.question === 13 ? e[IDS.ANSWER] !== IDS.NSNC : true
          ),
        (e) => e[IDS.QUESTION_OPTION]
      ),
      segment: "TOTAL",
      questionText: this.$t(`questions.${this.question}.question`),

      // options: [IDS.MUY_GRAVE, IDS.GRAVE, IDS.NSNC, IDS.POCO_GRAVE],
      orderBy: this.defaultOrder,
      orderDir: true,
      stacked: 1,
      groupingOptions: [
        { name: "Agrupado", value: 1 },
        { name: "Separado", value: 0 },
      ],
    };
  },
  computed: {
    barData() {
      return Array.from(this.data, ([name, values]) => ({
        name,
        values: values
          .map((e) => ({
            name: e[IDS.ANSWER],
            value: e[IDS[this.segment]],
          }))
          .sort((a, b) => {
            return this.order[b.name] - this.order[a.name];
          }),
        orderBy: values.find((e) => e[IDS.ANSWER] === this.orderBy)[
          IDS[this.segment]
        ],
      })).sort((a, b) => {
        return (b.orderBy - a.orderBy) * (this.orderDir ? 1 : -1);
      });
    },
    axis() {
      return Object.keys(this.order).map((_, i) =>
        max(this.barData.map((e) => e.values[i].value))
      );
    },
  },
  methods: {
    setOrder(val) {
      if (val === this.orderBy) {
        this.orderDir = !this.orderDir;
      } else this.orderBy = val;
    },
  },
  watch: {
    segment(val) {
      this.$emit("changeSegment", val);
    },
  },
};
</script>
